/**
 * Layout gate. Sign-in is disabled, so this no longer redirects anywhere — it
 * simply waits for the initial current-user load (the backend serves a built-in
 * local user) and then always renders the app.
 */

import React from "react";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({
  children,
}: {
  children: React.ReactElement;
}): React.ReactElement {
  const { isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-ink-950">
        <p className="text-sm text-mist-400">Loading…</p>
      </div>
    );
  }

  return children;
}
